import React from 'react';
import {Checkbox, Form, Icon, Input, Radio, Select} from 'antd';
import Signature from "./Signature";
import SignatureTrimmed from "./SignatureTrimmed";
import { withNamespaces } from 'react-i18next';

const { Option } = Select;

class ConsentLhsStep3aRegainedCapacity extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    const showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);
    const isEmail = props.consentMethodType === "EmailRegainedCapacity";
    const isSubjectFirst = props.email_consent_signature_order === "subject_first";

    return (
      <div className="form-group">
        <div className="form-group-details">
          <h4>{this.props.i18n.t('NamespaceConsentLhsStep3aRegainedCapacity:Consent Process - REGAINED CAPACITY CONSENT FORM')}</h4>

          {props.siteID && <h5>{this.props.i18n.t('Site ID')}: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>{this.props.i18n.t('User ID')}: <b>{props.userID}</b></h5>}
          <h5>{this.props.i18n.t('Subject ID')}: <b>{props.subjectID}</b></h5>
        </div>

        {props.has_randomization_platform_step_3_patient_regained_capacity ? <div
            dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_patient_regained_capacity_content}}/> : <h4 align="center">
          Template not loaded
          <br/>
          <br/>
        </h4>
        }
        <p><strong>{this.props.i18n.t('Server Date (UTC)')}: {props.consentDate || props.date}</strong></p>
        <p><strong>{this.props.i18n.t('Consent Type')}: {props.consentPersonType}</strong></p>
        <p><strong>{this.props.i18n.t('Consent Method')}: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        <div style={{ textAlign: 'left' }}>

          {showForEmail && <div>
            <Form.Item>
              <label>
                <div className='form-label'>{this.props.i18n.t('NamespaceConsentLhsStep3aRegainedCapacity:Please check the appropriate box to indicate your decision')}:</div>
                {props.form.getFieldDecorator('rccf_option', {
                  initialValue: props.rccf_option,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group disabled={props.signature_type === "investigator"}>
                    <Radio value='stay_in_study'>
                      {this.props.i18n.t('NamespaceConsentLhsStep3aRegainedCapacity:I wish to stay in the study.')}
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study'>
                      {this.props.i18n.t('NamespaceConsentLhsStep3aRegainedCapacity:I wish to withdraw from the study')}
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
            <Form.Item>
              <label>
                <div className='form-label' style={{ fontWeight: 'semibold', fontSize: '16px' }}>
                  WHAT IF RESEARCHERS DISCOVER SOMETHING ABOUT ME?
                </div>
                <div>
                  During the study, the researchers could learn something about you that they didn’t expect. For example, the researchers may find out that you have another medical condition. The researchers will consult with medical experts as needed to evaluate the findings and will then share these results with you. You will be helped with arranging appropriate follow up and care.
                </div>
                <div className='form-label' style={{ margin: '5px 0' }}>I consent for the researchers to share findings with me:</div>
                {props.form.getFieldDecorator('consent_question_rccf_researchers_share_findings_with_me', {
                  initialValue: props.consent_question_rccf_researchers_share_findings_with_me,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group disabled={props.signature_type === "investigator"}>
                    <Radio value={true}>
                      Yes
                    </Radio>
                    <br/>
                    <Radio value={false}>
                      No
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
            <Form.Item>
              <label>
                <div className='form-label' style={{ fontWeight: 'semibold', fontSize: '16px' }}>
                  USE OF DATA FOR FUTURE RESEARCH
                </div>
                <div className='form-label' style={{ margin: '5px 0' }}>My research data may be kept for use in future research to learn about, prevent or treat other health-related problems.</div>
                {props.form.getFieldDecorator('consent_question_rccf_use_my_research_data', {
                  initialValue: props.consent_question_rccf_use_my_research_data,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group disabled={props.signature_type === "investigator"}>
                    <Radio value={true}>
                      Yes
                    </Radio>
                    <br/>
                    <Radio value={false}>
                      No
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
            <Form.Item>
              <label>
                <div className='form-label' style={{ margin: '5px 0' }}>Additional blood/urine may be taken for this research, as described in the consent form.</div>
                {props.form.getFieldDecorator('consent_question_rccf_may_take_additional_samples', {
                  initialValue: props.consent_question_rccf_may_take_additional_samples,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group disabled={props.signature_type === "investigator"}>
                    <Radio value={true}>
                      Yes
                    </Radio>
                    <br/>
                    <Radio value={false}>
                      No
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

            <Form.Item>
              <label>
                <div className='form-label' style={{ fontWeight: 'semibold', fontSize: '16px' }}>
                  CONTACT FOR FUTURE RESEARCH
                </div>
                <div className='form-label' style={{ margin: '5px 0' }}>University of Calgary researchers may contact me in the future to ask me to take part in other research studies.</div>
                {props.form.getFieldDecorator('consent_question_rccf_future_contact', {
                  initialValue: props.consent_question_rccf_future_contact,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group disabled={props.signature_type === "investigator"}>
                    <Radio value={true}>
                      Yes
                    </Radio>
                    <br/>
                    <Radio value={false}>
                      No
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
          </div>}

          <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t('Name of Participant')}</div>
              {props.form.getFieldDecorator('rccf_subject_full_name', {
                initialValue: props.rccf_subject_full_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#000'}}/>}
                  placeholder="Name of Participant"
                />
              )}
            </label>
          </Form.Item>

          {!isEmail && <div>
            <Form.Item>
              {props.form.getFieldDecorator("email_consent_copy_to_subject", {
                initialValue: false,
                valuePropName: "checked",
              })(
                <Checkbox>
                  {this.props.i18n.t(
                    "NamespaceConsentLhsStep3aPatient:Send copy of consent via email"
                  )}
                </Checkbox>
              )}
            </Form.Item>

            {props.form.getFieldValue("email_consent_copy_to_subject") && <div>
              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      "NamespaceConsentLhsStep3aPatient:Patient Email"
                    )}
                  </div>
                  {props.form.getFieldDecorator("consent_subject_email", {
                    initialValue: props.consent_subject_email,
                    rules: [
                      {
                        required: true,
                        message: this.props.i18n.t(
                          "NamespaceConsentLhsStep3aPatient:Please enter the participant's email"
                        ),
                      },
                      { type: "email" },
                    ],
                  })(
                    <Input
                      disabled={props.token}
                      placeholder={this.props.i18n.t("email")}
                    />
                  )}
                </label>
              </Form.Item>
            </div>}
          </div>}

          {props.consentMethodType === 'EmailRegainedCapacity' && <Form.Item>
            {props.form.getFieldDecorator('rccf_subject_email', {
              initialValue: props.rccf_subject_email,
              rules: [{required: true, message: this.props.i18n.t('NamespaceConsentLhsStep3aRegainedCapacity:Please enter the participant\'s email')}, {type: 'email'}],
            })(
              <Input disabled={props.token} placeholder="email"/>
            )}
          </Form.Item>}

          {props.signature_type === "investigator" && props.rccf_subject_signature && <img src={props.rccf_subject_signature} width={250} alt='Subject Signature' />}

          {props.consentPersonType === 'Patient' && showForEmail && (isSubjectFirst && isEmail
            ? props.signature_type === "participant"
            : true) && (
            <div>
              <Signature fieldName='rccf_subject_signature' label={this.props.i18n.t('NamespaceConsentLhsStep3aRegainedCapacity:Signature of Participant')} form={props.form} />
            </div>
          )}

          {props.consentPersonType === 'Patient' && showForEmail && (isSubjectFirst && isEmail
            ? props.signature_type === "participant"
            : true) && <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t('NamespaceConsentLhsStep3aRegainedCapacity:Has the consent form been completed by all parties?')}</div>
              {props.form.getFieldDecorator('consent_provided', {
                initialValue: props.consent_provided,
                rules: [{
                  required: true,
                  message: this.props.i18n.t('NamespaceConsentLhsStep3aRegainedCapacity:Has the consent form been completed by all parties?')
                }],
              })(
                <Select>
                  <Option value="yes">{this.props.i18n.t('Yes')}</Option>
                  <Option value="">{this.props.i18n.t('No')}</Option>
                </Select>
              )}
            </label>
          </Form.Item>}

          <div>
            <Form.Item>
              <label>
                <div className='form-label'>{this.props.i18n.t('NamespaceConsentLhsStep3aRegainedCapacity:Name of Person Obtaining Consent')}</div>
                {props.form.getFieldDecorator('rccf_investigator_full_name', {
                  initialValue: props.rccf_investigator_full_name,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{color: '#000'}}/>}
                    placeholder={this.props.i18n.t('NamespaceConsentLhsStep3aRegainedCapacity:Name of Person Obtaining Consent')}
                  />
                )}
              </label>
            </Form.Item>

            <Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t(
                    "NamespaceConsentLhsStep3aPatient:Person Obtaining Consent Contact Number"
                  )}
                </div>
                {props.form.getFieldDecorator(
                  "rccf_investigator_contact_number",
                  {
                    initialValue: props.rccf_investigator_contact_number,
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  }
                )(
                  <Input
                    disabled={props.token}
                    placeholder={this.props.i18n.t(
                      "NamespaceConsentLhsStep3aPatient:Person obtaining consent contact number"
                    )}
                  />
                )}
              </label>
            </Form.Item>

            {((!props.token && !isSubjectFirst) ||
            props.signature_type === "investigator" || !isEmail) && <Signature fieldName='rccf_investigator_signature' label={this.props.i18n.t('NamespaceConsentLhsStep3aRegainedCapacity:Signature of Person Obtaining Consent')} form={props.form} />}
          </div>

          {isEmail && isSubjectFirst && !props.signature_type && (
            <Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t("Person Obtaining Consent Email")}
                </div>
                {props.form.getFieldDecorator("consent_investigator_email", {
                  initialValue: props.consent_investigator_email,
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t(
                        "NamespaceConsentLhsStep3aPatient:Please enter the person's obtaining consent email"
                      ),
                    },
                    { type: "email" },
                  ],
                })(
                  <Input
                    disabled={props.token}
                    placeholder={this.props.i18n.t("email")}
                  />
                )}
              </label>
            </Form.Item>
          )}


          {!isEmail && (
            <div>
              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      "NamespaceConsentLhsStep3aPatient:Witness Name (if applicable)"
                    )}
                  </div>
                  {props.form.getFieldDecorator(
                    "rccf_witness_full_name",
                    {
                      initialValue: props.rccf_witness_full_name,
                    }
                  )(
                    <Input
                      prefix={
                        <Icon type="user" style={{ color: "#000" }} />
                      }
                      placeholder={this.props.i18n.t(
                        "NamespaceConsentLhsStep3aPatient:Witness Name (if applicable)"
                      )}
                    />
                  )}
                </label>
              </Form.Item>

              <Signature
                fieldName="rccf_witness_signature"
                label="Signature of Witness (if applicable)"
                form={props.form}
                optional={true}
              />
            </div>
          )}

        </div>
      </div>
    );
  }
}

export default withNamespaces()(ConsentLhsStep3aRegainedCapacity)



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLhs/ConsentLhsStep3aRegainedCapacity.js